// import { useEffect, useState } from "react";
// import { SketchPicker } from "react-color";
// import { useSelector } from "react-redux";
// import { StoreProptypes } from "../../PropTypes/StoreProptypes";
// import { Form } from "react-bootstrap";
// import { useTranslation } from "react-i18next";

// interface PropTypes {
//     setChangeWidgetIconTextColor: Function, // function to set widget icon color
//     changeWidgetIconTextColor: string | null, // function to set widget icon color
//     setIsWidgetIconCustomTextColor: Function, // function to set widget icon color
//     isWidgetIconCustomTextColor: boolean // function to set widget icon color
// }

// // component to set widget icon color
// const WidgetIconTextColor = (props: PropTypes) => {

//     // Functions
//     const { t } = useTranslation();

//     // Props
//     const { setChangeWidgetIconTextColor, changeWidgetIconTextColor, setIsWidgetIconCustomTextColor, isWidgetIconCustomTextColor } = props;

//     // Redux Data
//     const { currentWebsite } = useSelector((store: StoreProptypes) => store);

//     // Stets
//     const [widgetTextColor, setWidgetTextColor] = useState<string | null>(null);

//     const [isWidgetTextCustomColor, setIsWidgetTextCustomColor] = useState<boolean>(isWidgetIconCustomTextColor ? true : false);

    
//     useEffect(() => {
//         // check if change widget icon color is available
//         if (changeWidgetIconTextColor) {
//             setWidgetTextColor(changeWidgetIconTextColor);
//         } else {
//             setWidgetTextColor(null)
//         }
//     }, [changeWidgetIconTextColor]);
   
//     useEffect(() => {
//         // check if change widget icon color is available
//         if (isWidgetIconCustomTextColor) {
//             setIsWidgetTextCustomColor(isWidgetIconCustomTextColor ? true : false);
//         } else {
//             setIsWidgetTextCustomColor(false)
//         }
//     }, [isWidgetIconCustomTextColor]);

//     // Set current widget icon type
//     useEffect(() => {
//         if (currentWebsite) {
//             // check if widget color is available
//             if (currentWebsite.widget_text_color) {
//                 setChangeWidgetIconTextColor(currentWebsite.widget_text_color);
//             } else {
//                 setChangeWidgetIconTextColor(null);
//             }
            
//             if (currentWebsite.is_widget_text_color) {
//                 setIsWidgetIconCustomTextColor(true);
//             } else {
//                 setIsWidgetIconCustomTextColor(false);
//             }
//         }
//     }, [currentWebsite]);

//     return (
//         <>
//             <div className="d-flex flex-column gap-4">
//                 <Form.Check
//                     type="switch"
//                     className="aioa_dashboard-switch"
//                     id="custom-switch-size"
//                      label={<span style={{ fontSize: "0.90rem" }}>
//                                                     {t('Enable custom text color')}
//                                                 </span>}
//                     checked={isWidgetTextCustomColor}
//                     onChange={(e) => setIsWidgetIconCustomTextColor(!isWidgetTextCustomColor)}
//                 />
//                 {isWidgetIconCustomTextColor && (
//                     <div className="border-top pt-4">
//                         <SketchPicker
//                             disableAlpha={true}
//                             color={widgetTextColor ?? undefined}
//                             onChange={(colorObject, e) => {
//                                 setChangeWidgetIconTextColor(colorObject.hex);
//                             }}
//                         />
//                     </div>
//                 )}
//             </div>
//         </>
//     )
// }

// export default WidgetIconTextColor;

import { useEffect, useState } from "react";
import { SketchPicker } from "react-color";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface PropTypes {
    setChangeWidgetIconTextColor: Function,
    changeWidgetIconTextColor: string | null,
    setIsWidgetIconCustomTextColor?: Function,
    isWidgetIconCustomTextColor?: boolean
}

// Default color options for text
const DEFAULT_TEXT_COLORS = [
    '#000000', // Black
    '#FFFFFF', // White
    '#FF4444', // Red
    '#4444FF', // Blue
    '#420083', // Purple
];

const WidgetIconTextColor = (props: PropTypes) => {

    const { t } = useTranslation();
    const { setChangeWidgetIconTextColor, changeWidgetIconTextColor, setIsWidgetIconCustomTextColor, isWidgetIconCustomTextColor } = props;
    const { currentWebsite } = useSelector((store: StoreProptypes) => store);
    const [widgetTextColor, setWidgetTextColor] = useState<string>('#000000');
    const [showColorPicker, setShowColorPicker] = useState<boolean>(false);
    const [isTextColorEnabled, setIsTextColorEnabled] = useState<boolean>(false);

    useEffect(() => {
        // Initialize toggle state from prop or website data
        if (isWidgetIconCustomTextColor !== undefined) {
            setIsTextColorEnabled(isWidgetIconCustomTextColor);
        } else if (currentWebsite?.is_widget_text_color) {
            setIsTextColorEnabled(true);
        } else {
            setIsTextColorEnabled(false);
        }
    }, [isWidgetIconCustomTextColor, currentWebsite]);

    useEffect(() => {
        if (changeWidgetIconTextColor && isTextColorEnabled) {
            setWidgetTextColor(changeWidgetIconTextColor);
            // Check if current color is in default colors, if not, show color picker
            if (!DEFAULT_TEXT_COLORS.includes(changeWidgetIconTextColor)) {
                setShowColorPicker(true);
            }
        } else {
            setWidgetTextColor('#000000');
            setShowColorPicker(false);
        }
    }, [changeWidgetIconTextColor, isTextColorEnabled]);

    // Set current widget text color from website data
    useEffect(() => {
        if (currentWebsite && isTextColorEnabled) {
            if (currentWebsite.widget_text_color) {
                setChangeWidgetIconTextColor(currentWebsite.widget_text_color);
            } else {
                setChangeWidgetIconTextColor('#000000');
            }
        }
    }, [currentWebsite, isTextColorEnabled]);

    const handleToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isEnabled = e.target.checked;
        setIsTextColorEnabled(isEnabled);
        
        if (setIsWidgetIconCustomTextColor) {
            setIsWidgetIconCustomTextColor(isEnabled);
        }
        
        if (!isEnabled) {
            // Reset color when toggle is off
            setChangeWidgetIconTextColor(null);
            setWidgetTextColor('#000000');
            setShowColorPicker(false);
        } else {
            // Set default color when toggle is turned on
            setChangeWidgetIconTextColor('#000000');
        }
    };

    const handleColorSelect = (color: string) => {
        setWidgetTextColor(color);
        setChangeWidgetIconTextColor(color);
        setShowColorPicker(false);
    };

    const handleCustomColor = () => {
        setShowColorPicker(true);
    };

    return (
        <div className="d-flex flex-column gap-4">
            {/* Toggle Switch */}
            <Form.Check
                type="switch"
                className="aioa_dashboard-switch"
                id="widget-text-color-toggle"
                label={<span style={{ fontSize: "0.90rem", fontWeight: "500" }}>
                    {t('Widget Text Color')}
                </span>}
                checked={isTextColorEnabled}
                onChange={handleToggleChange}
            />

            {/* Color Selection Section - Only shown when toggle is enabled */}
            {isTextColorEnabled && (
                <>
                    {/* Color Swatches */}
                    <div className="border-top pt-3">
                        <label style={{ fontSize: "0.85rem", marginBottom: "10px", display: "block", color: "#666" }}>
                            {t('Select Text Color')}
                        </label>
                        <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>
                            {DEFAULT_TEXT_COLORS.map((color) => (
                                <div
                                    key={color}
                                    onClick={() => handleColorSelect(color)}
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "50%",
                                        backgroundColor: color,
                                        cursor: "pointer",
                                        border: widgetTextColor === color ? "3px solid #000" : "3px solid transparent",
                                        boxShadow: widgetTextColor === color ? "0 0 0 2px #fff, 0 0 0 4px #000" : "none",
                                        transition: "all 0.2s ease",
                                        outline: color === '#FFFFFF' ? "1px solid #ddd" : "none"
                                    }}
                                />
                            ))}
                            
                            {/* Custom Color Button */}
                            <div
                                onClick={handleCustomColor}
                                style={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "50%",
                                    backgroundColor: "#f0f0f0",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: showColorPicker ? "2px solid #420083" : "2px solid #ddd",
                                    transition: "all 0.2s ease"
                                }}
                                title={t('Custom Color')}
                            >
                                <span style={{ fontSize: "18px", color: "#666" }}>✏️</span>
                            </div>
                        </div>
                    </div>

                    {/* Custom Color Picker (shown when pen icon is clicked) */}
                    {showColorPicker && (
                        <div className="mt-3" style={{ 
                            border: "1px solid #e0e0e0", 
                            borderRadius: "8px", 
                            padding: "15px",
                            backgroundColor: "#fff"
                        }}>
                            <div style={{ 
                                display: "flex", 
                                justifyContent: "space-between", 
                                alignItems: "center", 
                                marginBottom: "15px" 
                            }}>
                                <label style={{ fontSize: "0.85rem", color: "#666" }}>
                                    {t('Custom Color Picker')}
                                </label>
                                <button
                                    onClick={() => setShowColorPicker(false)}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        fontSize: "20px",
                                        cursor: "pointer",
                                        color: "#999"
                                    }}
                                >
                                    ×
                                </button>
                            </div>
                            <SketchPicker
                                disableAlpha={true}
                                color={widgetTextColor}
                                onChange={(colorObject) => {
                                    setWidgetTextColor(colorObject.hex);
                                    setChangeWidgetIconTextColor(colorObject.hex);
                                }}
                            />
                        </div>
                    )}

                    {/* Show selected color info */}
                    {!showColorPicker && widgetTextColor && !DEFAULT_TEXT_COLORS.includes(widgetTextColor) && (
                        <div className="mt-2" style={{ 
                            display: "flex", 
                            alignItems: "center", 
                            gap: "10px",
                            padding: "10px",
                            backgroundColor: "#f9f9f9",
                            borderRadius: "6px"
                        }}>
                            <div style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                backgroundColor: widgetTextColor,
                                border: widgetTextColor === '#FFFFFF' ? "1px solid #ddd" : "1px solid transparent"
                            }} />
                            <span style={{ fontSize: "0.85rem", color: "#666" }}>
                                {t('Current Color')}: {widgetTextColor}
                            </span>
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default WidgetIconTextColor;